import Seo from "@/components/feature/Seo";
import { SITE_DESCRIPTION, SITE_LOGO_URL, SITE_NAME, SITE_URL } from "@/lib/seo";
import Hero from "./components/Hero";
import StatsBar from "./components/StatsBar";
import ServicesSection from "./components/ServicesSection";
import FleetSection from "./components/FleetSection";
import ProcessSection from "./components/ProcessSection";
import GallerySection from "./components/GallerySection";
import TestimonialsSection from "./components/TestimonialsSection";
import CtaSection from "./components/CtaSection";

const organizationJsonLd: Record<string, unknown> = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: SITE_LOGO_URL,
  image: SITE_LOGO_URL,
  description: SITE_DESCRIPTION,
  areaServed: "Perú",
};

export default function Home() {
  return (
    <>
      <Seo
        title="Transporte, mudanzas y alquiler de unidades"
        description={SITE_DESCRIPTION}
        path="/"
        jsonLd={organizationJsonLd}
      />
      <Hero />
      <StatsBar />
      <ServicesSection />
      <FleetSection />
      <ProcessSection />
      <GallerySection />
      <TestimonialsSection />
      <CtaSection />
    </>
  );
}